import {ComboBoxControl} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";
import {HasTagCondition} from "../../Criteria/HasTagCondition";
import {InFolderCondition} from "../../Criteria/InFolderCondition";

type RulesetActionEntryType = {
    name: string;
    actionId: number;
}

const ThingMailActionList = [
    { label: 'Open', value: 0 },
    { label: 'Return to Sender', value: 1 },
    { label: 'Digital Store', value: 2 },
    { label: 'Physical Store', value: 3 },
    { label: 'Recycle', value: 4 },
    { label: 'Shred', value: 5 },
]

const RulesetActionEntry = (props: RulesetActionEntryType) => {
    const { setValue, getValues } = useFormContext();

    switch(props.actionId) {
        case 0:
            return (
                <HasTagCondition
                    name={`${props.name}.values`}
                    defaultValue={getValues(`${props.name}.values`)}
                    changeCallback={(e: any) => null}
                />
            )
        case 1:
            return (
                <HasTagCondition
                    name={`${props.name}.values`}
                    defaultValue={getValues(`${props.name}.values`)}
                    changeCallback={(e: any) => null}
                />
            )
        case 2:
            return (
                <InFolderCondition
                    name={`${props.name}.values`}
                    defaultValue={getValues(`${props.name}.values`)}
                    changeCallback={(e: any) => null}
                />
            )
        case 3:
            return (
                <InFolderCondition
                    name={`${props.name}.values`}
                    defaultValue={getValues(`${props.name}.values`)}
                    changeCallback={(e: any) => null}
                />
            )
        case 4:
            return (
                <div />
            )
        case 5:
            return (
                <ComboBoxControl
                    name={`${props.name}.values`}
                    placeholder={'Select Mail Action...'}
                    data={ThingMailActionList}
                    defaultValues={getValues(`${props.name}.values`) ? [getValues(`${props.name}.values`)] : undefined}
                    singleSelection={true}
                    valueType={'number'}
                    forwardValueCallback={(val) => {
                        setValue(`${props.name}.values`, val)
                    }}
                />
            )
        case 6:
            return (
                <div />
            )
        default:
            return <div />
    }
}

export { RulesetActionEntry }
